import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import { showDialog } from 'vant';
import { rqtGetCustomerForIdentify } from '@/services/cms/customer';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      btnLoading: false,
      isLevel01Customer: '否',
      form: {
        chnName: undefined,
        idNo: undefined
      },
      codeResItems: [],
      customer: {}
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    // this.initResCodeType(this.codeResItems)
  },
  methods: {
    onSubmit() {
      this.btnLoading = true;
      rqtGetCustomerForIdentify({
        chnName: this.form.chnName,
        idNo: this.form.idNo
      }).then(res => {
        this.btnLoading = false;
        // this.$message.success('操作成功')
        // this.$router.go(-1)
        // console.log('----------res-----: ',res.data.data)
        if (res.data.data) {
          this.isLevel01Customer = '是';
        }
        showDialog({
          title: '是否是签单客户：' + this.isLevel01Customer
        }).then(() => {
          this.isLevel01Customer = '否';
        });
      }).catch(() => {
        this.btnLoading = false;
      });
    }
  }
};